<template>
  <div>
    <div class="header">
      <!-- <img src="@/assets/logo.png" class="logo" alt="" /> -->

     <!-- <div class="titles">
        <router-link class="menu" to="/">星火首页</router-link>
        <router-link class="menu" to="/page">手机投屏</router-link>
        <router-link class="menu" to="/page1">远程管理</router-link>
        <router-link class="menu" to="/page2">远程桌面</router-link>
        <router-link class="menu" to="/page3">应用场景</router-link>
        <router-link class="menu" to="/page4">私有化</router-link>
        <router-link class="menu" to="/page5">矩阵设备</router-link>
        <router-link class="menu" to="/page6">下载</router-link>
        <router-link class="menu" to="/page7">代理招募</router-link>
        <router-link class="menu" to="/page8">关于我们</router-link>
      </div> -->

      <div class="right">
        <!-- <div class="register" @click="toRegister">注册</div> -->
        <!-- <div class="out">退出登录</div> -->
         <div class="out">.</div> 
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {},
  methods: {
    toRegister() {
      this.$router.push("/regist");
    },
  },
};
</script>

<style scoped>
.header {
  width: 100%;
  height: 60px;
  background: #46acff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header .titles {
  display: flex;
  width: 1000px;
}
.header .titles .menu {
  flex: 1;
}
.out {
  margin-right: 20px;
}
.logo {
  width: 65px;
  height: 60px;
  background: rgb(29, 228, 89);
}
.right {
  display: flex;
  width: 150px;
  justify-content: space-between;
}
.right div {
  cursor: pointer;
}
</style>
